import "./SavingsBanner.css";

function CalculatorIcon({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="4" y="2.5" width="16" height="19" rx="2.5" stroke="currentColor" strokeWidth="1.75" />
      <rect x="7" y="5" width="10" height="4" rx="1" fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="8.5" cy="13" r="1" fill="currentColor" />
      <circle cx="12" cy="13" r="1" fill="currentColor" />
      <circle cx="15.5" cy="13" r="1" fill="currentColor" />
      <circle cx="8.5" cy="16.5" r="1" fill="currentColor" />
      <circle cx="12" cy="16.5" r="1" fill="currentColor" />
      <circle cx="15.5" cy="16.5" r="1" fill="currentColor" />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg className="savings-banner__arrow" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M3 8h10M9.5 4.5 13 8l-3.5 3.5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SavingsBanner({ onCalculate }) {
  return (
    <aside className="savings-banner" aria-label="Compare home care costs on NEMA CareHub">
      <div className="savings-banner__info">
        <span className="savings-banner__icon" aria-hidden>
          <CalculatorIcon />
        </span>
        <div className="savings-banner__copy">
          <h3 className="savings-banner__heading">
            Want More Control Over Your Home Care Costs?
          </h3>
          <p className="savings-banner__body">
            Explore available care professionals, compare rates and understand applicable fees
            before making your hiring decision.
          </p>
        </div>
      </div>

      <div className="savings-banner__divider" aria-hidden />

      <div className="savings-banner__cta-wrap">
        <button type="button" className="savings-banner__cta" onClick={onCalculate}>
          <CalculatorIcon className="savings-banner__cta-icon" />
          <span>Compare Care Costs</span>
          <ArrowIcon />
        </button>
      </div>
    </aside>
  );
}
